import React from 'react';
import PropTypes from 'prop-types';

import EmployeesTableCell from './EmployeesTableCell';

const getEmployeeName = (employee) => `${employee.firstName} ${employee.lastName}`;

const EmployeesTable = ({ employeeFields, employees, handleOpenViewModal }) => {
  return (
    <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
      <thead className="bg-gray-200">
        <tr>
          {employeeFields.map((field) => (
            <th key={field.key} className="px-4 py-2 text-left font-bold text-sss-blue-sel">
              {field.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="text-gray-700">
        {employees.map((employee) => (
          <tr key={employee.id} className="border-t">
            {employeeFields.map((field) => (
              <EmployeesTableCell
                key={field.key}
                field={field}
                employee={{ ...employee, employeeName: getEmployeeName(employee) }}
                handleOpenViewModal={handleOpenViewModal}
              />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

EmployeesTable.propTypes = {
  employeeFields: PropTypes.array.isRequired,
  employees: PropTypes.array.isRequired,
  handleOpenViewModal: PropTypes.func.isRequired,
};

export default EmployeesTable;
